import { user } from 'ampersand-app'
import { merge } from 'lodash'
import FineUploaderTraditional from 'fine-uploader-wrappers'
import lang from '@/lang'
import documentConfig from '@/modules/document/config'

const ALLOWED_FILE_EXTENSIONS = ['jpeg', 'jpg', 'png', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'xml', 'csv']
const MAX_FILES_PER_UPLOAD = 25
const MAX_FILESIZE_BYTES = 25 * 1024 * 1024
const MAX_IMAGE_HEIGHT = 3000
const MAX_IMAGE_WIDTH = 3000
const ERROR_REASONS = {
  TOO_MANY_FILES_ERROR: 'tooManyFilesError',
  NO_FILES_TO_UPLOAD: 'No files to upload.',
}

const allowedExtensionsStrings = ALLOWED_FILE_EXTENSIONS.map(ext => `'${ext}'`).join(', ')

const getUploader = (options, itemLimit = MAX_FILES_PER_UPLOAD) => {
  const defaultOptions = {
    autoUpload: false,
    messages: {
      typeError: lang.fileUploaderTypesError.replace('%s', allowedExtensionsStrings),
      sizeError: lang.fileUploaderSizeError,
      maxHeightImageError: lang.fileUploaderMaxHeightImageError.replace('%s', MAX_IMAGE_HEIGHT),
      maxWidthImageError: lang.fileUploaderMaxWidthImageError.replace('%s', MAX_IMAGE_WIDTH),
      tooManyItemsError: lang.fileUploaderTooManyItemsError(itemLimit),
    },
    validation: {
      allowedExtensions: options.validation?.allowedExtensions || ALLOWED_FILE_EXTENSIONS,
      itemLimit: itemLimit ?? options.validation?.itemLimit ?? 25,
      sizeLimit: MAX_FILESIZE_BYTES,
      image: {
        maxHeight: MAX_IMAGE_HEIGHT,
        maxWidth: MAX_IMAGE_WIDTH,
      },
    },
    request: {
      customHeaders: { authorization: `Bearer ${user?.token}` },
      endpoint: documentConfig.uploadUrl,
      inputName: 'file',
      params: options.params || {},
    },
  }

  return new FineUploaderTraditional({
    options: merge(defaultOptions, options),
  })
}

export default getUploader

export {
  getUploader,
  ALLOWED_FILE_EXTENSIONS,
  ERROR_REASONS,
}
